import Icon from "assets/icons";
import React from "react";
import { CarouselProps } from "./types";
import useCarouselService from "./useCarouselService";
import classNames from "classnames";
import Button from "../button";

/**
 * @description Render this once carousal items are available
 */
function Carousel(props: CarouselProps) {
  const service = useCarouselService(props);
  return (
    <div className={classNames("carousel--wrapper", props.className)}>
      {service.showScrollButtons && (
        <Button
          className={classNames("carousel--nav prev", {
            scrollButtonVisibilityHidden: service.scrollButtonVisibilityHidden
          })}
          onClick={service.handleBack}
          disabled={!service.showBackButton}
          icon={<Icon.ArrowLeft />}
        />
      )}
      <div ref={service.carouselRef} onScroll={service.onScroll} className="carousel--content">
        {props.children}
      </div>
      {service.showScrollButtons && (
        <Button
          className={classNames("carousel--nav next", {
            scrollButtonVisibilityHidden: service.scrollButtonVisibilityHidden
          })}
          onClick={service.handleNext}
          disabled={!service.showNextButton}
          icon={<Icon.ArrowRight />}
        />
      )}
    </div>
  );
}

export default Carousel;

export function CarouselItem(props: { children: React.ReactNode; className?: string }) {
  return <div className={props.className}>{props.children}</div>;
}
